<template>
  <div class="sidebar">
    <ul class="projects">
      <li v-for="project in documents" class="projects__group" :key="project.name">
        <h2 class="project-main-name px-4 py-3">{{project.name }}</h2>
        <ul class="projects-list">

          <Project @click:item="updateItem"
        :selectedItem="selectedItem" :content="project.content.details" />
        </ul>
      </li>
    </ul>
    
  </div>
</template>

<script>

import Project from "./Project.vue";

export default {
  name: "Sidebar",
  components: {
    Project,
  },
  props: {
    documents: {
      type: Array,
      required: false,
    },
    selectedItem: {
      type: null,
      required: false,
    },
  },
  methods: {
    updateItem(item) {
      this.$emit("update:item", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.arrow {
  &:hover {
    cursor: pointer;
  }
}
</style>
